
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owners/whats-new",
      function () {
        return require("private-next-pages/owners/whats-new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/owners/whats-new"])
      });
    }
  